module.exports = __webpack_public_path__ + "img/flower-2.d5ac7d36.png";